<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <!-- Page Header: start -->
          <div class="md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
              <h2 class="
                  text-2xl
                  font-light
                  leading-7
                  text-gray-900
                  sm:text-2xl sm:leading-9 sm:truncate
                ">
                Fragen
              </h2>
            </div>
            <div class="mt-4 flex md:mt-0 md:ml-4">
              <span class="sm:ml-3 shadow-sm rounded-md">
                <Link :href="route('admin.questions.create')" class="
                    inline-flex
                    items-center
                    px-4
                    py-2
                    border border-transparent
                    text-sm
                    font-medium
                    rounded-md
                    text-gray-500
                    bg-gray-300
                    shadow-sm
                    hover:bg-gray-400 hover:text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-gray-400
                  ">Neue Frage</Link>
              </span>
            </div>
          </div>
          <!-- Page Header: end -->

          <horizontal-divider />

          <!-- Filter: start -->
          <div class="flex flex-col sm:flex-row mb-4">
            <div class="mr-2 sm:w-7/12">
              <div class="mt-1 relative rounded-md shadow-sm">
                <div class="
                    absolute
                    inset-y-0
                    left-0
                    pl-3
                    flex
                    items-center
                    pointer-events-none
                  ">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <input type="search" class="
                    mt-1
                    pl-10
                    focus:ring-gray-400 focus:border-gray-400
                    block
                    w-full
                    sm:text-sm
                    border-gray-300
                    rounded-md
                  " placeholder="Suchen nach..." v-model="form.search" />
              </div>
            </div>

            <div class="sm:w-5/12 flex">
              <div class="w-10/12 sm:w-11/12 mr-2">
                <select v-model="form.partner_id" class="
                    mt-1
                    block
                    w-full
                    py-2
                    px-3
                    border border-gray-300
                    bg-white
                    rounded-md
                    shadow-sm
                    focus:outline-none focus:ring-gray-400 focus:border-gray-400
                    sm:text-sm
                  ">
                  <option value="">
                    Alle Partner
                  </option>
                  <option v-for="partner in partners" :value="partner.id" :key="partner.id">
                    {{ partner.name }}
                  </option>
                </select>
              </div>

              <div class="w-2/12 sm:w-1/12 text-center mt-3">
                <button v-if="isFiltered" v-tooltip.left="'Filter zurücksetzen'" @click="reset">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-500 hover:text-markencode-blue">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>

                <div v-if="!isFiltered">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-300">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!-- Filter: end -->

          <!-- List: start -->
          <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <ul>
              <li v-for="(question, idx) in questions" :key="question.id"
                :class="idx ? 'border-t border-gray-200' : ''">

                <component :is="question.question_type != 'radio' ? 'a' : 'span'" :href="question.question_type != 'radio' ? route('admin.questions.edit', { id: question.id }) : ''"
                class="
                    block
                    hover:bg-gray-50
                    focus:outline-none focus:bg-gray-50
                    transition
                    duration-150
                    ease-in-out
                  ">
                  <div class="flex items-start px-4 py-4 sm:px-6">

                    <!-- question: start -->
                    <div class="
                        min-w-0
                        w-3/5
                        px-4
                      ">
                      <div>
                        <div class="
                            text-sm
                            leading-5
                            font-medium
                            text-gray-600
                            
                          ">
                          {{ question.question }}

                          <span v-if="question?.question_type == 'radio'"
                            class="block text-xs sm:inline italic text-gray-400">{{
    question?.parameters?.choices.join(',')
  }}</span>
                        </div>
                        <div v-if="false" class="text-sm leading-5 font-normal text-gray-400">
                          {{ question.placeholder_question }}
                        </div>
                      </div>

                      <!-- partner selection: start -->
                      <div v-if="partners" class="mt-3">
                        <div 
                        @click.prevent.stop="togglePartner(question, partner)"
                        v-for="(partner, idx) in partners"
                        :key="partner.id"
                        class="cursor-pointer w-fit float-left py-0.5 px-1 mr-2 mb-1  text-xs text-white rounded-md hover:bg-markencode-blue"
                        :class="isPartnerInQuestion(partner, question.partners) ? 'bg-markencode-blue' : 'bg-gray-300'"
       
                        >
                          {{ partner.name  }}
                        </div>
                      </div>
                      <!-- partner selection: end -->
                    </div>
                    <!-- question: end -->


                    <!-- question-type: start -->
                    <div class="
                        min-w-0
                        w-1/5
                        flex-1
                        px-4
                      ">
                      <div>
                        <div class="
                            text-sm
                            leading-5
                            font-medium
                            text-gray-600
                            
                          ">
                          {{ questionType(question) }}
                        </div>
                        <div class="text-sm leading-5 font-normal text-gray-400">
                          {{ liveResultsType(question) }}
                        </div>
                      </div>

                    </div>
                    <!-- question-type: end -->



                    <div>
                      <svg v-if="question.question_type != 'radio'" class="h-5 w-5 text-gray-400" fill="currentColor"
                        viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clip-rule="evenodd" />
                      </svg>

                      <svg v-if="question.question_type == 'radio'" 
                      v-tooltip.top="`Options-Fragen (Radio) können zur Zeit noch nicht bearbeitet oder angelegt werden`"
                      xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                      </svg>

                    </div>
                  </div>
                </component>
              </li>
            </ul>
          </div>
          <!-- List: end -->
        </div>
      </div>
    </div>

    <confirm-modal v-if="confirmModal.visible" :headline="confirmModal.headline" :text="confirmModal.text"
      @close="confirmModal.visible = false" @confirm="deleteQuestionConfirmed"></confirm-modal>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import PartnerLogo from '@/Shared/PartnerLogo.vue';
// TODO: extract the confirmation modal to a decoupled component
import ConfirmModal from '@/Shared/ConfirmModal.vue';
import { pickBy, debounce, mapValues, some, isNotEmpty } from 'lodash';

export default {
  metaInfo: { title: 'Fragen' },

  components: {
    Layout,
    HorizontalDivider,
    PartnerLogo,
    ConfirmModal,
  },

  props: ['filters', 'questions', 'partners'],

  data() {
    return {
      confirmModal: {
        visible: false,
        itemId: null,
        headline: 'Frage löschen',
        text: '',
      },
      form: {
        search: this.filters.search || '',
        partner_id: this.filters.partner_id || '',
      },
    };
  },

  computed: {
    isFiltered() {
      return some(this.form, isNotEmpty);
    },
  },

  watch: {
    form: {
      handler: debounce(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.route(
            'admin.questions.index',
            Object.keys(query).length ? query : { remember: 'forget' }
          )
        );
      }, 250),
      deep: true,
    },
  },

  methods: {
    isPartnerInQuestion(partner, questionPartners) {
      return questionPartners.some(qp => qp.id === partner.id);
    },

    togglePartner(question, partner) {
      // if (this.isPartnerInQuestion(partner, question.partners)) {
      //   question.partners = question.partners.filter(qp => qp.id !== partner.id);
      // } else {
      //   question.partners.push(partner);
      // } 

      this.$inertia.post(
        this.route('admin.questions.toggle-partner', { id: question.id, partnerId: partner.id }),
        {},
        {
          preserveScroll: true,
          preserveState: false,
          // onSuccess: (page) => {
          //   this.userStatusProcessing = null;
          // },
        }
      );
    },

    reset() {
      this.form = mapValues(this.form, () => null);
    },

    deleteUser(question) {
      this.confirmModal.itemId = question.id;
      this.confirmModal.text = `Soll die Frage ${question.question} wirklich gelöscht werden?`;
      this.confirmModal.visible = true;
    },

    deleteQuestionConfirmed() {
      if (!this.confirmModal.itemId) return;

      this.sending = true;

      this.$inertia.delete(
        this.route('admin.questions.delete', {
          id: this.confirmModal.itemId,
        }),
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.sending = false;
            this.confirmModal.visible = false;
          },
        }
      );
    },

    questionType(question) {
      if (question.question_type == 'textblock_multiple') {
        return 'Mehrfach-Textbox';
      }

      if (question.question_type == 'textblock_single') {
        return 'Textbox';
      }

      if (question.question_type == 'keywords') {
        return 'Schlagworte';
      }

      if (question.question_type == 'choices') {
        return 'Einfach-/Mehrfachauswahl';
      }

      if (question.question_type == 'radio') {
        return 'Optionen (Radio)';
      }
    },

    liveResultsType(question) {
      if (question.live_results_type == 'scrollable_container') {
        return 'Scroll-Ansicht';
      }

      if (question.live_results_type == 'word_cloud') {
        return 'Wort-Cloud';
      }

      if (question.live_results_type == 'piechart') {
        return 'Pie-Chart';
      }

      if (question.live_results_type == 'barchart') {
        return 'Bar-Chart';
      }
    },
  },
};
</script>
